<template>
  <div>

  <div class="popup">
    <div class="turn-the-phone">
      <div class="turn-the-phone__circle"></div>
      <div class="turn-the-phone__message">Vänd telefonen för att visa listan.</div>

      <button class="go-back" @click="goBack">Gå tillbaka</button>
    </div>
  </div>

  <router-view></router-view>
  <Loading :show="loading" text="Hämtar boenden" />
  <Loading :show="isAwaitingFilter" text="Laddar skillnader" />
  <div :class="{component: true, disabled: (loading || isAwaitingFilter)}">

    <!-- <h1>Jämför och dela dina boendetips med när och kära</h1> -->
    <h1>Jämför upp till 3 boenden</h1>

    <!-- <button :class="{disabled: (accomodations.length < 1), white: true, border: true, medium: true}" @click="openModal(['AccomodationCompareShare', {
      accomodations: ($route.query.boenden ? $route.query.boenden : favoriteAccommodations.join(','))
      }])">Dela med en vän <icon name="share-blue" /></button> -->
    <div style="display:inline-block;" :class="{disabled: (accomodations.length <= 1)}">
      <SwitchButton
        icon="compare"
        :iconscale="2"
        :value="false"
        :sync="false"
        :labels="{ checked: 'Visar skillnader', unchecked: 'Visa skillnader'}"
        @toggle="changeValue" />
    </div>

    <p>Jämför intressanta boenden. Du kan också klicka på filtret visa skillnader för att bara se det som skiljer valda boenden.</p>

    <div class="flex">
      <div v-for="(unit, key) in accomodations">
        <div class="image" :style="'background-image:url(' + (unit && unit.pool && unit.pool.image) + ')'">
          <div class="icon-bg" v-if="fromMemory">
            <button class="white small border" @click="removeFavoriteLocal(key)">
              <icon name="trash" :scale="2" />
            </button>
          </div>
        </div>

        <h2>{{(unit.display_name || unit.description_title)}}</h2>
        <button class="medium" @click="openInfo(unit)">Info/boka</button>
        <button class="medium white border" @click="openMap(unit)">Visa på karta <icon name="map-blue" :scale="1.7" /></button>

        <div class="fact-container">
          <div v-if="!onlyDifferences || (onlyDifferences && differs('bedrooms'))" :class="'fact ' + (unit.bedrooms ? 'active' : '')">
            <icon name="antal rum" :scale="1.4" />
            Sovrum ({{unit.bedrooms}}st)
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('living_area'))" :class="'fact ' + (unit.living_area ? 'active' : '')">
            <icon name="area" :scale="1.4" />
            Boarea ({{unit.living_area}}m2)
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('internet'))" :class="'fact ' + (unit.internet ? 'active' : '')">
            <icon name="wifi" :scale="1.4" />
            Wi-Fi
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('washing_machine'))" :class="'fact ' + (unit.washing_machine ? 'active' : '')">
            <icon name="tvattmaskin-black" :scale="1.4" />
            Tvättmaskin
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('terrace_balcony'))" :class="'fact ' + (unit.terrace_balcony ? 'active' : '')">
            <icon name="balkong" :scale="1.4" />
            Balkong/altan
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('dishwasher'))" :class="'fact ' + (unit.dishwasher ? 'active' : '')">
            <icon name="diskmaskin-black" :scale="1.4" />
            Diskmaskin
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('pets_allowed'))" :class="'fact ' + (unit.pets_allowed ? 'active' : '')">
            <icon name="husdjur-black" :scale="1.4" />
            Husdjur tillåtna
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('sauna'))" :class="'fact ' + (unit.sauna ? 'active' : '')">
            <icon name="bastu-black" :scale="1.4" />
            Bastu
          </div>
          <div v-if="!SITE_CONFIG.settings.SettingLockTypes.active && (!onlyDifferences || (onlyDifferences && differs('direct_incheck')))" :class="'fact ' + (unit.direct_incheck ? 'active' : '')">
            <icon name="direkt-incheck-black" :scale="1.4" />
            Digital incheckning
          </div>

          <div v-if="SITE_CONFIG.settings.SettingLockTypes.active && (!onlyDifferences || (onlyDifferences && differs('lock_type_id')))"  
            :class="'fact ' + (unit.lock_type_id ? 'active' : '')"
            >
            <icon name="direkt-incheck-black" :scale="1.4" />
            {{ unit.lock_type_id ? SITE_CONFIG.settings.SettingLockTypes.texts[unit.lock_type_id].title : Object.values(SITE_CONFIG.settings.SettingLockTypes.texts).map(function (item) {return item.title;}).join(' / ') }}
          </div>

          <div v-if="!onlyDifferences || (onlyDifferences && differs('handicap_rooms'))" :class="'fact ' + (unit.handicap_rooms ? 'active' : '')">
            <icon name="handikapp" :scale="1.4" />
            Handikappanpassat
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('dryer_cabinet'))" :class="'fact ' + (unit.dryer_cabinet ? 'active' : '')">
            <icon name="torkskap" :scale="1.4" />
            Torkskåp
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('toilets'))" :class="'fact ' + (unit.toilets ? 'active' : '')">
            <icon name="wc" :scale="1.4" />
            WC ({{unit.toilets}}st)
          </div>
          <div v-if="(!onlyDifferences || (onlyDifferences && differs('hot_tub'))) && SITE_CONFIG.site != 'branas'" :class="'fact ' + (unit.hot_tub ? 'active' : '')">
            <icon name="badtunna" :scale="1.4" />
            Badtunna
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('extra_beds'))" :class="'fact ' + (unit.extra_beds ? 'active' : '')">
            <icon name="sangar" :scale="1.4" />
            Extrabäddar ({{unit.extra_beds}}st)
          </div>

          <div v-if="!onlyDifferences || (onlyDifferences && differs('final_cleaning_included'))" :class="'fact ' + (unit.final_cleaning_included ? 'active' : '')">
            <div>
              <icon name="stadning-black" :scale="1.4" />
              Slutstäd (ingår)
            </div>
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('final_cleaning_available'))" :class="'fact ' + (unit.final_cleaning_available ? 'active' : '')">
            <div>
              <icon name="stadning-black" :scale="1.4" />
              Slutstäd (tillval)
            </div>
          </div>

          <div v-if="!onlyDifferences || (onlyDifferences && differs('child_friendly'))" :class="'fact ' + (unit.child_friendly ? 'active' : '')">
            <icon name="smiley-black" :scale="1.4" />
            Extra barnanpassat
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('beds'))" :class="'fact ' + (unit.beds ? 'active' : '')">
            <icon name="sangar" :scale="1.4" />
            Bäddar ({{unit.beds}}st)
          </div>
          <div v-if="!onlyDifferences || (onlyDifferences && differs('fireplace'))" :class="'fact ' + (unit.fireplace ? 'active' : '')">
            <icon name="kamin" :scale="1.4" />
            Öppen spis
          </div>

          <div v-if="SITE_CONFIG.accomodations.filters.chargeStation && (!onlyDifferences || (onlyDifferences && differs('charging_post')))" :class="'fact ' + (unit.charging_post ? 'active' : '')">
            <icon name="laddstolpe-black" :scale="1.4" />
            Laddstolpe
          </div>
        </div>
      </div>
      <div v-if="accomodations.length < 3 && fromMemory" @click="goToAccomodations">
        <div class="add-icon">
        </div>
        <b class="add-more">Lägg till fler boenden <br> och jämför</b>
      </div>
    </div>

  </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import API from '@/classes/API';
import SwitchButton from '@/components/components/SwitchButton';
import Loading from '@/components/components/Loading';

export default {
  components: {
    SwitchButton,
    Loading,
  },
  data() {
    return {
      accomodations: [],
      onlyDifferences: false,
      fromMemory: true,
      loading: false,
    };
  },
  beforeMount() {
    /* if (this.favoriteAccommodations.length
      && (!this.$route.query.boenden || !this.$route.query.boenden.length)) {
      this.$router.replace({ query: {
        boenden: this.favoriteAccommodations.join(','),
      } });
    } */
  },
  async mounted() {
    this.load();
  },
  /* created() {
    document.body.classList.add('modal-opened');
  },
  destroyed() {
    document.body.classList.remove('modal-opened');
  }, */
  methods: {
    ...mapMutations([
      'removeFavorite',
      'openModal',
      'closeModal',
      'awaitFilter',
    ]),
    goToAccomodations() {
      this.$router.push('/boenden');
    },
    removeFavoriteLocal(payload) {
      const $this = this;
      if ($this.fromMemory) {
        $this.openModal(['GeneralModal', {
          type: 'confirm',
          content: 'Vill du ta bort boendet från din jämförelselista?',
          yes: () => {
            $this.closeModal();
            $this.removeFavorite(payload);
            this.load();
          },
          no: () => {
            $this.closeModal();
          },
        }]);
      } else {
        const query = this.$route.query.boenden.split(',');
        query.splice(payload, 1);
        this.$router.replace({ query: {
          boenden: query.join(','),
        } });
        this.load();
      }
    },
    changeValue(v) {
      this.awaitFilter();
      this.onlyDifferences = v.value;
    },
    async load() {
      this.loading = true;
      let accomodations = null;

      if (this.$route.query.boenden && this.$route.query.boenden.length) {
        accomodations = this.$route.query.boenden.split(',');
        this.fromMemory = false;
      } else {
        accomodations = this.favoriteAccommodations;
        this.fromMemory = true;
      }

      /* eslint-disable */
      this.accomodations = [];
      for (let i in accomodations) {
        let fav = accomodations[i];
        if (i < 3) {
          const { data } = await API.get(`/units/${fav}/info-by-id`);
          this.accomodations.push(data);
        }
      }

      this.loading = false;
    },
    differs(prop) {
      let picked = [];
      for (let i in this.accomodations) {
        let unit = this.accomodations[i];
        picked.push(unit[prop]);
      }

      var first = picked[0];
      const ret = picked.every(function(element) {
        return element === first;
      });
      return !ret;
    },
    openInfo(unit) {
      this.$router.push({ path: `/jamfor-boenden/info/${unit.slug}?flow=jamfor-boenden` });
    },
    openMap(unit) {
      this.openModal([`MapModal${this.SITE_CONFIG.site}`, {
        locationId: (unit.facility ? unit.facility.id : null),
        areaId: unit.pool.id,
        type: 'view',
      }]);
    },
    goBack() {
      window.history.go(-1);
    },
  },
  computed: {
    ...mapGetters([
      'favoriteAccommodations',
      'isAwaitingFilter',
    ]),
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.SwitchButton
  padding-bottom: 1px;
  padding-top: 6px;

.icon--map-blue
  position: relative
  top -4px
  margin-left: 5px

button
  margin-right: 10px
  margin-left: 10px


.add-icon
  width: 148px;
  height: 148px;
  background-color: var(--booking-color-primary);
  border-radius 50%
  background-image url(https://static.booking.branasgruppen.se/static/svg/plus-white.svg)
  background-size 50%
  background-position center center
  background-repeat no-repeat
  margin 20px auto 35px auto
  cursor pointer

.add-more
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  color: #262626;
  cursor pointer

.component
  max-width 1100px
  margin 0 auto
  padding-top: 25px
  text-align center
  .flex
    display flex
    justify-content center
    & > div
      width 30%
      margin-left: 1.6%
      margin-right: 1.6%
      .image
        background-size cover
        padding-top 60%
        position relative
        .icon-bg
          position absolute
          top 0
          right 0
          padding 5px
          background-color white
          border-bottom-left-radius 4px
          button
            background-color pale-sky
            margin-left 0
            margin-right 0
            .icon
              margin-left 0
      h2
        united-heavy()
        font-size 22px
        uppercase()
        margin-top 15px
        margin-bottom 15px
  p
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    color: #262626;
    max-width 750px
    margin 20px auto 55px auto

.fact-container
  margin-top: 20px
  margin-bottom: 40px

.fact
  .icon
    margin-right 10px
    opacity 0.2
  color: #cccccc;
  text-decoration:line-through
  font-size: 15px;
  font-weight: 300;
  font-family: Interstate;
  padding: 14px 15px;
  text-align left
  &:nth-child(2n+2)
    background-color: #f9f9f9;
  &.active
    text-decoration:none
    color: #262626;
    .icon
      opacity 1

.disabled
  disabled-grey()

@media (min-width:568px) {
  .popup {
    display: none;
  }
}
@media (max-width:567px) {
  .flex {
    display: none !important;
  }
  .popup {
    display: block;
    position:fixed;
    top: 0;
    left:0;
    width: 100%;
    height 100%;
    text-align: center;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.8);
    padding-top: 20%;
    overflow: hidden;
    display: block;
  }
  .popup .turn-the-phone {
    max-width:190px;
    display: inline-block;
  }
  .popup .turn-the-phone .go-back {
    margin-top: 25px;
  }
  .popup .turn-the-phone__message {
    font-family: Interstate;
    font-size: 15px;
    font-weight: bold;
    line-height: 1.13;
    text-align: center;
    color: var(--booking-color-primary);
    border-radius: 3px;
    background-color: #ffffff;
    padding:10px 18px;
  }
  .popup .turn-the-phone__circle {
    width:100%;
    padding-top:100%;
    border-radius: 50%;
    background-color: var(--booking-color-primary);
    border: solid 3px #ffffff;
    margin-bottom:15px;
    position: relative;
  }
  .popup .turn-the-phone__circle:after {
    content:"";
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-image:url(https://cdn.branasgruppen.se/branas/app/uploads/2025/03/12121206/rotate-phone.svg);
    background-size:55%;
    background-repeat: no-repeat;
    background-position: 47% 46%;
  }
}
</style>



// WEBPACK FOOTER //
// AccomodationsCompare.vue?4f08abe7